<template>
  <div>
    <el-dialog title="详情" top="1%" :visible.sync="companyShow" width="60%" :close-on-click-modal="false">
      <div class="certify-table">
        <table border="0" cellspacing="0" cellpading="0" width="100%">
          <template v-if="infoData.enterprise">
            <tr>
              <td class="t_title">企业名称：</td>
              <td class="t_text">{{ infoData.enterprise.fullName }}</td>
              <td class="t_title">企业简称：</td>
              <td class="t_text">{{ infoData.enterprise.simpleName }}</td>
            </tr>
            <tr>
              <td class="t_title">企业简介：</td>
              <td :colspan="3" class="t_text">{{ infoData.enterprise.introduction }}</td>
            </tr>
            <tr>
              <td class="t_title">所属行业：</td>
              <td class="t_text">{{ infoData.enterprise.industry }}</td>
              <td class="t_title">企业性质：</td>
              <td class="t_text">{{ infoData.enterprise.nature }}</td>
            </tr>
            <tr>
              <td class="t_title">地址：</td>
              <td class="t_text" colspan="3">{{ infoData.enterprise.address }}</td>

            </tr>
            <tr>
              <td class="t_title">证照类型：</td>
              <td class="t_text">{{ infoData.enterprise.idType }}</td>
              <td class="t_title">证照编号：</td>
              <td class="t_text">{{ infoData.enterprise.idNumber }}</td>
            </tr>
            <tr>
              <td class="t_title">证照有效期：</td>
              <td class="t_text" colspan="3">
                {{ (new Date(infoData.enterprise.lifeSpanStart*1000)).toLocaleString() }} -- {{ (new Date(infoData.enterprise.lifeSpanEnd*1000)).toLocaleString() }}
              </td>
            </tr>
            <tr>
              <td class="t_title">证件照：</td>
              <td class="t_text" colspan="3">
                <el-image style="width: 60px; height: 60px" :src="infoData.enterprise.idImgUrl" :preview-src-list="[infoData.enterprise.idImgUrl]">
                </el-image>
              </td>
            </tr>
          </template>
          <template v-if="infoData.legalPerson">
            <tr>
              <td class="t_title">法人姓名：</td>
              <td class="t_text">
                {{infoData.legalPerson.realName}}
              </td>
              <td class="t_title">证件类型：：</td>
              <td class="t_text">{{infoData.legalPerson.idType}}</td>
            </tr>
            <tr>
              <td class="t_title">证件号码：</td>
              <td class="t_text" colspan="3">
                {{infoData.legalPerson.idNumber}}
              </td>
            </tr>
            <tr>
              <td class="t_title">证件照前面：</td>
              <td class="t_text">
                <el-image style="width: 60px; height: 60px" :src="infoData.legalPerson.idImgFrontUrl" :preview-src-list="[infoData.legalPerson.idImgFrontUrl]">
                </el-image>
              </td>
              <td class="t_title">证件照后面：</td>
              <td class="t_text">
                <el-image style="width: 60px; height: 60px" :src="infoData.legalPerson.idImgBackUrl" :preview-src-list="[infoData.legalPerson.idImgBackUrl]">
                </el-image>
              </td>
            </tr>
          </template>

          <template v-if="infoData.contractPerson">
            <tr>
              <td class="t_title">企业联系人：</td>
              <td class="t_text">{{infoData.contractPerson.name}}
              </td>
              <td class="t_title">职位：</td>
              <td class="t_text">{{infoData.contractPerson.position}}</td>
            </tr>
            <tr>
              <td class="t_title">手机号码：</td>
              <td class="t_text">{{infoData.contractPerson.phoneNumber}}
              </td>
              <td class="t_title">授权书：</td>
              <td class="t_text">
                <el-image style="width: 60px; height: 60px" :src="infoData.contractPerson.poaImgUrl" :preview-src-list="[infoData.contractPerson.poaImgUrl]">
                </el-image>
              </td>
            </tr>
          </template>

        </table>
      </div>
      <div class="certify-btn">
        <el-button type="warning" @click="handleAudit">资料审核</el-button>
        <el-button type="primary" @click="handleCertify(3)">认证通过</el-button>
        <el-button type="danger" @click="handleCertify(4)">认证失败</el-button>
      </div>
      <enterprise-edit-dialog
        :dialog-visible="editDialogVisible"
        :is-edit="true"
        :company-id="infoData.id || ''"
        @handleClose="editDialogVisible = false"
        @updated="handleUpdated"
      />
    </el-dialog>
  </div>
</template>

<script>
import { checkCompany, getEnterpriseInfo } from '@/api/certify'
import EnterpriseEditDialog from '@/views/dashboard/component/companyDialog.vue'

export default {
  components: {
    EnterpriseEditDialog
  },
  props: {
    dialogVisible: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      infoData: {},
      companyShow: false,
      editDialogVisible: false
    }
  },
  watch: {
    dialogVisible: {
      handler(newval) {
        this.companyShow = Boolean(newval && newval.show)
        this.infoData = (newval && newval.detailData) || {}
      }
    }
  },
  methods: {
    async handleCertify(val) {
      await checkCompany({ id: this.infoData.id, status: val })
      const msg = val == 3 ? '企业认证成功' : '企业认证失败'
      this.$message.success(msg)
      this.companyShow = false
      this.$emit('getCompanyList')
    },
    handleAudit() {
      this.editDialogVisible = true
    },
    async handleUpdated() {
      this.infoData = await getEnterpriseInfo({ id: this.infoData.id })
      this.$emit('getCompanyList')
    }
  }
}
</script>

<style lang="less" scoped>
.certify-table {
  width: 100%;
  table {
    border-collapse: collapse;
  }
  td {
    height: 60px;
    font-size: 14px;
    font-weight: 600;
    background: #fbfcff;
    border: 1px solid #e6e6e6;
  }
  .t_title {
    width: 100px;
    padding-left: 30px;
    color: #333333;
  }
  .t_text {
    padding-left: 20px;
    color: #2868e8;
  }
}

.certify-btn {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}
</style>
